<template>
  <OrderlineTimeline v-if="timeline" :timeline />
  <OrderlineCardReplaced
    v-if="orderlineState.enumState === 'REPLACED' && replacementOrderline"
    :replacement-orderline
  />
  <OrderlineCardExpressReplacementOngoing
    v-if="
      orderlineState.enumState === 'EXPRESS_REPLACE_ONGOING' &&
      expressReplacedByReplacementOrderline
    "
    :express-replaced-by-replacement-orderline
  />
  <OrderlineCardExpressReplacementComplete
    v-if="orderlineState.enumState === 'EXPRESS_REPLACE_COMPLETE'"
  />
  <template v-if="refundDate">
    <OrderlineCardRefund
      v-if="orderlineState.enumState === 'REFUNDED'"
      :refund-date
    />
    <OrderlineCardCancel
      v-if="orderlineState.enumState === 'CANCELLED'"
      :refund-date
    />
  </template>
</template>

<script lang="ts" setup>
import OrderlineTimeline from '@/scopes/care-commons/components/order/OrderlineTimeline/OrderlineTimeline.vue'
import type { ExpressReplacedByReplacementOrderline } from '~/api/my-orders/types/OrderlineExpressReplacement.types'
import type { Orderline } from '~/api/my-orders/types/OrderlineList.types'
import OrderlineCardExpressReplacementOngoing from '~/scopes/care-commons/components/order/OrderlineCard/components/OrderlineCardContent/components/OrderlineCardExpressReplacementOngoing/OrderlineCardExpressReplacementOngoing.vue'

import OrderlineCardCancel from './components/OrderlineCardCancel/OrderlineCardCancel.vue'
import OrderlineCardExpressReplacementComplete from './components/OrderlineCardExpressReplacementComplete/OrderlineCardExpressReplacementComplete.vue'
import OrderlineCardRefund from './components/OrderlineCardRefund/OrderlineCardRefund.vue'
import OrderlineCardReplaced from './components/OrderlineCardReplaced/OrderlineCardReplaced.vue'

export interface OrderlineCardContentProps {
  orderlineState: Orderline['state']
  refundDate: Orderline['refundDate']
  timeline: Orderline['timeline'] | null
  replacementOrderline: Orderline['replacedByReplacementOrderline']
  expressReplacedByReplacementOrderline?: ExpressReplacedByReplacementOrderline | null
}

defineProps<OrderlineCardContentProps>()
</script>
